<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-5">
            
            <div class="text-center p-2">
                <h3>{{ $t('auth.userProfileComplete.title') }}</h3>
            </div>
        
            <div class="text-center p-2">
                {{ $t('auth.userProfileComplete.text') }}
            </div>
        
        </div>

        <div class="text-center">
            <div class="pb-4 ">
                <a id="top" class="btn btn-primary" href="/" role="button" @click="handleOnClickLogout()">{{$t('auth.userProfileComplete.topBtn') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'edit-user-profile-module',
        methods: {
            handleOnClickLogout(e) {
                this.$router.push('');
            },
        }
    }
</script>
